export class RamShareCheckResult {
    'found';
    'ramResourceShareArn';
    'error';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "found",
            "baseName": "found",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "ramResourceShareArn",
            "baseName": "ramResourceShareArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RamShareCheckResult.attributeTypeMap;
    }
    constructor() {
    }
}
